export function getCondensersMissingReason(
  placedCondenserCount: number,
  requiredCondensers: number
): string | undefined {
  if (placedCondenserCount >= requiredCondensers) return undefined;
  const missing = requiredCondensers - placedCondenserCount;
  const noun = missing === 1 ? 'condenser' : 'condensers';
  return `Place ${missing} more ${noun} (${placedCondenserCount}/${requiredCondensers})`;
}

export const CONDENSER_BEFORE_ZONES_REASON =
  'Place a condenser before adding zones';

export function getZoneStepMissingReason(options: {
  canStartZones: boolean;
  cannotStartReason?: string;
  isFirstZone: boolean;
  currentZoneHasSpaces: boolean;
}): string | undefined {
  const {
    canStartZones,
    cannotStartReason = CONDENSER_BEFORE_ZONES_REASON,
    isFirstZone,
    currentZoneHasSpaces
  } = options;
  if (!canStartZones && isFirstZone) {
    return cannotStartReason;
  }
  if (!currentZoneHasSpaces) {
    return 'Add at least one space to this zone';
  }
  return undefined;
}

export const NO_SYSTEMS_FOR_CONFIGURATION_REASON =
  'No systems can serve this configuration as drawn. Change the zones before placing air handlers.';

export function getAirHandlersMissingReason(
  zonesWithAirHandlersCount: number,
  totalZonesWithItemsCount: number,
  noSystemsForConfiguration = false
): string | undefined {
  if (totalZonesWithItemsCount === 0) {
    return 'Add zones before placing air handlers';
  }
  if (noSystemsForConfiguration) return NO_SYSTEMS_FOR_CONFIGURATION_REASON;
  if (zonesWithAirHandlersCount >= totalZonesWithItemsCount) return undefined;
  return `Add an air handler to all zones (${zonesWithAirHandlersCount}/${totalZonesWithItemsCount})`;
}

export function getLineSetsMissingReason(
  linkedAirHandlerCount: number,
  totalAirHandlerCount: number
): string | undefined {
  if (totalAirHandlerCount === 0) {
    return 'Add air handlers before linking line sets';
  }
  if (linkedAirHandlerCount >= totalAirHandlerCount) return undefined;
  return `Connect all air handlers to a condenser (${linkedAirHandlerCount}/${totalAirHandlerCount})`;
}

export const NO_ELIGIBLE_CONFIGURATION_REASON =
  'Complete at least one configuration with at least one valid system';

export const SYSTEM_PREVIEW_MISSING_REASON = 'Waiting for valid systems';

export const PTAC_DESIGN_ISSUES_REASON =
  'Resolve the PTAC design issues before choosing systems';
